// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Variables for S-CUBUS Theme System */

:root {
  /* Primary Brand Colors */
  --color-primary: #370b3b;
  --color-primary-light: #4a1548;
  --color-primary-dark: #2a0829;
  --color-primary-rgb: 55, 11, 59;
  --color-primary-alpha: rgba(55, 11, 59, 0.1);
  
  /* Secondary Colors */
  --color-secondary: #f39c12;
  --color-secondary-light: #f5b041;
  --color-secondary-dark: #d68910;
  --color-secondary-rgb: 243, 156, 18;
  
  /* Accent Colors */
  --color-accent: #e74c3c;
  --color-accent-light: #ec7063;
  --color-accent-dark: #c0392b;
  --color-accent-rgb: 231, 76, 60;
  
  /* Success/Warning/Error Colors */
  --color-success: #27ae60;
  --color-success-light: #58d68d;
  --color-success-dark: #1e8449;
  --color-success-rgb: 39, 174, 96;
  
  --color-warning: #f39c12;
  --color-warning-light: #f5b041;
  --color-warning-dark: #d68910;
  --color-warning-rgb: 243, 156, 18;
  
  --color-error: #e74c3c;
  --color-error-light: #ec7063;
  --color-error-dark: #c0392b;
  --color-error-rgb: 231, 76, 60;
  
  --color-info: #3498db;
  --color-info-light: #5dade2;
  --color-info-dark: #2980b9;
  --color-info-rgb: 52, 152, 219;
  
  /* Light Theme Colors */
  --color-background: #ffffff;
  --color-background-rgb: 255, 255, 255;
  --color-surface: #f8f9fa;
  --color-surface-rgb: 248, 249, 250;
  --color-surface-elevated: #ffffff;
  --color-surface-elevated-rgb: 255, 255, 255;
  --color-surface-dark: #2c3e50;
  --color-surface-dark-rgb: 44, 62, 80;
  
  --color-text: #2c3e50;
  --color-text-rgb: 44, 62, 80;
  --color-text-secondary: #7f8c8d;
  --color-text-secondary-rgb: 127, 140, 141;
  --color-text-muted: #95a5a6;
  --color-text-muted-rgb: 149, 165, 166;
  --color-text-light: #ffffff;
  --color-text-light-rgb: 255, 255, 255;
  
  --color-border: #e9ecef;
  --color-border-rgb: 233, 236, 239;
  --color-border-light: #f1f3f4;
  --color-border-light-rgb: 241, 243, 244;
  --color-border-dark: #404040;
  --color-border-dark-rgb: 64, 64, 64;
  
  --color-shadow: rgba(0, 0, 0, 0.1);
  --color-shadow-light: rgba(0, 0, 0, 0.05);
  --color-shadow-dark: rgba(0, 0, 0, 0.2);
  
  /* Typography Scale */
  --font-family-primary: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-family-heading: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-family-mono: 'Fira Code', 'Monaco', 'Cascadia Code', monospace;
  
  /* Font Sizes */
  --font-size-xs: 0.75rem;    /* 12px */
  --font-size-sm: 0.875rem;   /* 14px */
  --font-size-base: 1rem;     /* 16px */
  --font-size-lg: 1.125rem;   /* 18px */
  --font-size-xl: 1.25rem;    /* 20px */
  --font-size-2xl: 1.5rem;    /* 24px */
  --font-size-3xl: 1.875rem;  /* 30px */
  --font-size-4xl: 2.25rem;   /* 36px */
  --font-size-5xl: 3rem;      /* 48px */
  --font-size-6xl: 3.75rem;   /* 60px */
  --font-size-7xl: 4.5rem;    /* 72px */
  --font-size-8xl: 6rem;      /* 96px */
  --font-size-9xl: 8rem;      /* 128px */
  
  /* Font Weights */
  --font-weight-thin: 100;
  --font-weight-extralight: 200;
  --font-weight-light: 300;
  --font-weight-normal: 400;
  --font-weight-medium: 500;
  --font-weight-semibold: 600;
  --font-weight-bold: 700;
  --font-weight-extrabold: 800;
  --font-weight-black: 900;
  
  /* Line Heights */
  --line-height-none: 1;
  --line-height-tight: 1.25;
  --line-height-snug: 1.375;
  --line-height-normal: 1.5;
  --line-height-relaxed: 1.625;
  --line-height-loose: 2;
  
  /* Letter Spacing */
  --letter-spacing-tighter: -0.05em;
  --letter-spacing-tight: -0.025em;
  --letter-spacing-normal: 0em;
  --letter-spacing-wide: 0.025em;
  --letter-spacing-wider: 0.05em;
  --letter-spacing-widest: 0.1em;
  
  /* Spacing Scale */
  --spacing-0: 0;
  --spacing-px: 1px;
  --spacing-0-5: 0.125rem;  /* 2px */
  --spacing-1: 0.25rem;     /* 4px */
  --spacing-1-5: 0.375rem;  /* 6px */
  --spacing-2: 0.5rem;      /* 8px */
  --spacing-2-5: 0.625rem;  /* 10px */
  --spacing-3: 0.75rem;     /* 12px */
  --spacing-3-5: 0.875rem;  /* 14px */
  --spacing-4: 1rem;        /* 16px */
  --spacing-5: 1.25rem;     /* 20px */
  --spacing-6: 1.5rem;      /* 24px */
  --spacing-7: 1.75rem;     /* 28px */
  --spacing-8: 2rem;        /* 32px */
  --spacing-9: 2.25rem;     /* 36px */
  --spacing-10: 2.5rem;     /* 40px */
  --spacing-11: 2.75rem;    /* 44px */
  --spacing-12: 3rem;       /* 48px */
  --spacing-14: 3.5rem;     /* 56px */
  --spacing-16: 4rem;       /* 64px */
  --spacing-20: 5rem;       /* 80px */
  --spacing-24: 6rem;       /* 96px */
  --spacing-28: 7rem;       /* 112px */
  --spacing-32: 8rem;       /* 128px */
  --spacing-36: 9rem;       /* 144px */
  --spacing-40: 10rem;      /* 160px */
  --spacing-44: 11rem;      /* 176px */
  --spacing-48: 12rem;      /* 192px */
  --spacing-52: 13rem;      /* 208px */
  --spacing-56: 14rem;      /* 224px */
  --spacing-60: 15rem;      /* 240px */
  --spacing-64: 16rem;      /* 256px */
  --spacing-72: 18rem;      /* 288px */
  --spacing-80: 20rem;      /* 320px */
  --spacing-96: 24rem;      /* 384px */
  
  /* Border Radius */
  --radius-none: 0;
  --radius-sm: 0.125rem;   /* 2px */
  --radius-base: 0.25rem;  /* 4px */
  --radius-md: 0.375rem;   /* 6px */
  --radius-lg: 0.5rem;     /* 8px */
  --radius-xl: 0.75rem;    /* 12px */
  --radius-2xl: 1rem;      /* 16px */
  --radius-3xl: 1.5rem;    /* 24px */
  --radius-full: 9999px;
  
  /* Border Widths */
  --border-width-0: 0px;
  --border-width-1: 1px;
  --border-width-2: 2px;
  --border-width-4: 4px;
  --border-width-8: 8px;
  
  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-base: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --shadow-inner: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  --shadow-none: 0 0 #0000;
  
  /* Transitions */
  --transition-none: none;
  --transition-all: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-base: 250ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 350ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slower: 500ms cubic-bezier(0.4, 0, 0.2, 1);
  
  /* Easing Functions */
  --ease-linear: linear;
  --ease-in: cubic-bezier(0.4, 0, 1, 1);
  --ease-out: cubic-bezier(0, 0, 0.2, 1);
  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
  
  /* Z-Index Scale */
  --z-auto: auto;
  --z-0: 0;
  --z-10: 10;
  --z-20: 20;
  --z-30: 30;
  --z-40: 40;
  --z-50: 50;
  --z-dropdown: 1000;
  --z-sticky: 1020;
  --z-fixed: 1030;
  --z-modal-backdrop: 1040;
  --z-modal: 1050;
  --z-popover: 1060;
  --z-tooltip: 1070;
  --z-toast: 1080;
  --z-max: 2147483647;
  
  /* Responsive Breakpoints */
  --breakpoint-xs: 475px;
  --breakpoint-sm: 640px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 1024px;
  --breakpoint-xl: 1280px;
  --breakpoint-2xl: 1536px;
  
  /* Container Max Widths */
  --container-xs: 475px;
  --container-sm: 640px;
  --container-md: 768px;
  --container-lg: 1024px;
  --container-xl: 1280px;
  --container-2xl: 1536px;
  
  /* Grid System */
  --grid-columns: 12;
  --grid-gap: var(--spacing-6);
  --grid-gap-sm: var(--spacing-4);
  --grid-gap-lg: var(--spacing-8);
  
  /* Component Specific Variables */
  --navbar-height: 4rem;
  --sidebar-width: 16rem;
  --footer-height: auto;
  
  /* Animation Durations */
  --duration-75: 75ms;
  --duration-100: 100ms;
  --duration-150: 150ms;
  --duration-200: 200ms;
  --duration-300: 300ms;
  --duration-500: 500ms;
  --duration-700: 700ms;
  --duration-1000: 1000ms;
}

/* High Contrast Theme (Accessibility) */
[data-theme="high-contrast"] {
  --color-background: #000000;
  --color-background-rgb: 0, 0, 0;
  --color-surface: #000000;
  --color-surface-rgb: 0, 0, 0;
  --color-surface-elevated: #1a1a1a;
  --color-surface-elevated-rgb: 26, 26, 26;
  
  --color-text: #ffffff;
  --color-text-rgb: 255, 255, 255;
  --color-text-secondary: #ffffff;
  --color-text-secondary-rgb: 255, 255, 255;
  --color-text-muted: #cccccc;
  --color-text-muted-rgb: 204, 204, 204;
  
  --color-border: #ffffff;
  --color-border-rgb: 255, 255, 255;
  --color-border-light: #cccccc;
  --color-border-light-rgb: 204, 204, 204;
  
  --color-primary: #ffffff;
  --color-primary-rgb: 255, 255, 255;
  --color-secondary: #ffff00;
  --color-secondary-rgb: 255, 255, 0;
  --color-accent: #ff0000;
  --color-accent-rgb: 255, 0, 0;
  
  --color-success: #00ff00;
  --color-success-rgb: 0, 255, 0;
  --color-warning: #ffff00;
  --color-warning-rgb: 255, 255, 0;
  --color-error: #ff0000;
  --color-error-rgb: 255, 0, 0;
  --color-info: #00ffff;
  --color-info-rgb: 0, 255, 255;
}

/* Reduced Motion Preferences */
@media (prefers-reduced-motion: reduce) {
  :root {
    --transition-none: none;
    --transition-all: none;
    --transition-fast: none;
    --transition-base: none;
    --transition-slow: none;
    --transition-slower: none;
    
    --duration-75: 0ms;
    --duration-100: 0ms;
    --duration-150: 0ms;
    --duration-200: 0ms;
    --duration-300: 0ms;
    --duration-500: 0ms;
    --duration-700: 0ms;
    --duration-1000: 0ms;
  }
}

/* High Contrast Preference */
@media (prefers-contrast: high) {
  :root:not([data-theme]) {
    --color-border: #000000;
    --color-text: #000000;
    --color-background: #ffffff;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/frontend/styles/variables.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,4CAA4C;;EAE5C,qBAAqB;EACrB,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,mCAAmC;;EAEnC,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;;EAE/B,iCAAiC;EACjC,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;;EAEhC,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;;EAEjC,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;;EAE9B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;;EAE9B,uBAAuB;EACvB,2BAA2B;EAC3B,qCAAqC;EACrC,wBAAwB;EACxB,kCAAkC;EAClC,iCAAiC;EACjC,2CAA2C;EAC3C,6BAA6B;EAC7B,oCAAoC;;EAEpC,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;EAC/B,yCAAyC;EACzC,2BAA2B;EAC3B,qCAAqC;EACrC,2BAA2B;EAC3B,qCAAqC;;EAErC,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;EACvC,4BAA4B;EAC5B,mCAAmC;;EAEnC,kCAAkC;EAClC,yCAAyC;EACzC,uCAAuC;;EAEvC,qBAAqB;EACrB,qGAAqG;EACrG,qGAAqG;EACrG,qEAAqE;;EAErE,eAAe;EACf,uBAAuB,KAAK,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,sBAAsB,MAAM,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,uBAAuB,KAAK,SAAS;EACrC,uBAAuB,KAAK,SAAS;EACrC,yBAAyB,GAAG,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,qBAAqB,OAAO,SAAS;EACrC,wBAAwB,IAAI,SAAS;EACrC,uBAAuB,KAAK,SAAS;EACrC,qBAAqB,OAAO,SAAS;EACrC,qBAAqB,OAAO,UAAU;;EAEtC,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;;EAExB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;;EAEtB,mBAAmB;EACnB,iCAAiC;EACjC,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uBAAuB,GAAG,QAAQ;EAClC,oBAAoB,MAAM,QAAQ;EAClC,uBAAuB,GAAG,QAAQ;EAClC,mBAAmB,OAAO,QAAQ;EAClC,uBAAuB,GAAG,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,uBAAuB,GAAG,SAAS;EACnC,iBAAiB,SAAS,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,mBAAmB,OAAO,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,iBAAiB,SAAS,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,qBAAqB,KAAK,SAAS;EACnC,kBAAkB,QAAQ,SAAS;EACnC,oBAAoB,MAAM,SAAS;EACnC,kBAAkB,QAAQ,SAAS;EACnC,kBAAkB,QAAQ,SAAS;EACnC,kBAAkB,QAAQ,SAAS;EACnC,kBAAkB,QAAQ,UAAU;EACpC,kBAAkB,QAAQ,UAAU;EACpC,kBAAkB,QAAQ,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;EACpC,mBAAmB,OAAO,UAAU;;EAEpC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,IAAI,QAAQ;EACjC,sBAAsB,GAAG,QAAQ;EACjC,qBAAqB,IAAI,QAAQ;EACjC,mBAAmB,MAAM,QAAQ;EACjC,oBAAoB,KAAK,SAAS;EAClC,kBAAkB,OAAO,SAAS;EAClC,oBAAoB,KAAK,SAAS;EAClC,qBAAqB;;EAErB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,YAAY;EACZ,4CAA4C;EAC5C,8EAA8E;EAC9E,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;EACtF,mDAAmD;EACnD,qDAAqD;EACrD,wBAAwB;;EAExB,gBAAgB;EAChB,uBAAuB;EACvB,wDAAwD;EACxD,qDAAqD;EACrD,qDAAqD;EACrD,qDAAqD;EACrD,uDAAuD;;EAEvD,qBAAqB;EACrB,qBAAqB;EACrB,qCAAqC;EACrC,sCAAsC;EACtC,2CAA2C;;EAE3C,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,UAAU;EACV,UAAU;EACV,UAAU;EACV,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;;EAEnB,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;;EAExB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;;EAEvB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;;EAE/B,iCAAiC;EACjC,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;;EAErB,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;EAC5B,iCAAiC;EACjC,wCAAwC;;EAExC,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,yCAAyC;EACzC,2BAA2B;EAC3B,qCAAqC;;EAErC,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;;EAEvC,wBAAwB;EACxB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,uBAAuB;EACvB,6BAA6B;;EAE7B,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,gCAAgC;EAChC,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;;IAEzB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;EAC7B;;AAEF","sourcesContent":["/* CSS Variables for S-CUBUS Theme System */\r\n\r\n:root {\r\n  /* Primary Brand Colors */\r\n  --color-primary: #370b3b;\r\n  --color-primary-light: #4a1548;\r\n  --color-primary-dark: #2a0829;\r\n  --color-primary-rgb: 55, 11, 59;\r\n  --color-primary-alpha: rgba(55, 11, 59, 0.1);\r\n  \r\n  /* Secondary Colors */\r\n  --color-secondary: #f39c12;\r\n  --color-secondary-light: #f5b041;\r\n  --color-secondary-dark: #d68910;\r\n  --color-secondary-rgb: 243, 156, 18;\r\n  \r\n  /* Accent Colors */\r\n  --color-accent: #e74c3c;\r\n  --color-accent-light: #ec7063;\r\n  --color-accent-dark: #c0392b;\r\n  --color-accent-rgb: 231, 76, 60;\r\n  \r\n  /* Success/Warning/Error Colors */\r\n  --color-success: #27ae60;\r\n  --color-success-light: #58d68d;\r\n  --color-success-dark: #1e8449;\r\n  --color-success-rgb: 39, 174, 96;\r\n  \r\n  --color-warning: #f39c12;\r\n  --color-warning-light: #f5b041;\r\n  --color-warning-dark: #d68910;\r\n  --color-warning-rgb: 243, 156, 18;\r\n  \r\n  --color-error: #e74c3c;\r\n  --color-error-light: #ec7063;\r\n  --color-error-dark: #c0392b;\r\n  --color-error-rgb: 231, 76, 60;\r\n  \r\n  --color-info: #3498db;\r\n  --color-info-light: #5dade2;\r\n  --color-info-dark: #2980b9;\r\n  --color-info-rgb: 52, 152, 219;\r\n  \r\n  /* Light Theme Colors */\r\n  --color-background: #ffffff;\r\n  --color-background-rgb: 255, 255, 255;\r\n  --color-surface: #f8f9fa;\r\n  --color-surface-rgb: 248, 249, 250;\r\n  --color-surface-elevated: #ffffff;\r\n  --color-surface-elevated-rgb: 255, 255, 255;\r\n  --color-surface-dark: #2c3e50;\r\n  --color-surface-dark-rgb: 44, 62, 80;\r\n  \r\n  --color-text: #2c3e50;\r\n  --color-text-rgb: 44, 62, 80;\r\n  --color-text-secondary: #7f8c8d;\r\n  --color-text-secondary-rgb: 127, 140, 141;\r\n  --color-text-muted: #95a5a6;\r\n  --color-text-muted-rgb: 149, 165, 166;\r\n  --color-text-light: #ffffff;\r\n  --color-text-light-rgb: 255, 255, 255;\r\n  \r\n  --color-border: #e9ecef;\r\n  --color-border-rgb: 233, 236, 239;\r\n  --color-border-light: #f1f3f4;\r\n  --color-border-light-rgb: 241, 243, 244;\r\n  --color-border-dark: #404040;\r\n  --color-border-dark-rgb: 64, 64, 64;\r\n  \r\n  --color-shadow: rgba(0, 0, 0, 0.1);\r\n  --color-shadow-light: rgba(0, 0, 0, 0.05);\r\n  --color-shadow-dark: rgba(0, 0, 0, 0.2);\r\n  \r\n  /* Typography Scale */\r\n  --font-family-primary: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\r\n  --font-family-heading: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\r\n  --font-family-mono: 'Fira Code', 'Monaco', 'Cascadia Code', monospace;\r\n  \r\n  /* Font Sizes */\r\n  --font-size-xs: 0.75rem;    /* 12px */\r\n  --font-size-sm: 0.875rem;   /* 14px */\r\n  --font-size-base: 1rem;     /* 16px */\r\n  --font-size-lg: 1.125rem;   /* 18px */\r\n  --font-size-xl: 1.25rem;    /* 20px */\r\n  --font-size-2xl: 1.5rem;    /* 24px */\r\n  --font-size-3xl: 1.875rem;  /* 30px */\r\n  --font-size-4xl: 2.25rem;   /* 36px */\r\n  --font-size-5xl: 3rem;      /* 48px */\r\n  --font-size-6xl: 3.75rem;   /* 60px */\r\n  --font-size-7xl: 4.5rem;    /* 72px */\r\n  --font-size-8xl: 6rem;      /* 96px */\r\n  --font-size-9xl: 8rem;      /* 128px */\r\n  \r\n  /* Font Weights */\r\n  --font-weight-thin: 100;\r\n  --font-weight-extralight: 200;\r\n  --font-weight-light: 300;\r\n  --font-weight-normal: 400;\r\n  --font-weight-medium: 500;\r\n  --font-weight-semibold: 600;\r\n  --font-weight-bold: 700;\r\n  --font-weight-extrabold: 800;\r\n  --font-weight-black: 900;\r\n  \r\n  /* Line Heights */\r\n  --line-height-none: 1;\r\n  --line-height-tight: 1.25;\r\n  --line-height-snug: 1.375;\r\n  --line-height-normal: 1.5;\r\n  --line-height-relaxed: 1.625;\r\n  --line-height-loose: 2;\r\n  \r\n  /* Letter Spacing */\r\n  --letter-spacing-tighter: -0.05em;\r\n  --letter-spacing-tight: -0.025em;\r\n  --letter-spacing-normal: 0em;\r\n  --letter-spacing-wide: 0.025em;\r\n  --letter-spacing-wider: 0.05em;\r\n  --letter-spacing-widest: 0.1em;\r\n  \r\n  /* Spacing Scale */\r\n  --spacing-0: 0;\r\n  --spacing-px: 1px;\r\n  --spacing-0-5: 0.125rem;  /* 2px */\r\n  --spacing-1: 0.25rem;     /* 4px */\r\n  --spacing-1-5: 0.375rem;  /* 6px */\r\n  --spacing-2: 0.5rem;      /* 8px */\r\n  --spacing-2-5: 0.625rem;  /* 10px */\r\n  --spacing-3: 0.75rem;     /* 12px */\r\n  --spacing-3-5: 0.875rem;  /* 14px */\r\n  --spacing-4: 1rem;        /* 16px */\r\n  --spacing-5: 1.25rem;     /* 20px */\r\n  --spacing-6: 1.5rem;      /* 24px */\r\n  --spacing-7: 1.75rem;     /* 28px */\r\n  --spacing-8: 2rem;        /* 32px */\r\n  --spacing-9: 2.25rem;     /* 36px */\r\n  --spacing-10: 2.5rem;     /* 40px */\r\n  --spacing-11: 2.75rem;    /* 44px */\r\n  --spacing-12: 3rem;       /* 48px */\r\n  --spacing-14: 3.5rem;     /* 56px */\r\n  --spacing-16: 4rem;       /* 64px */\r\n  --spacing-20: 5rem;       /* 80px */\r\n  --spacing-24: 6rem;       /* 96px */\r\n  --spacing-28: 7rem;       /* 112px */\r\n  --spacing-32: 8rem;       /* 128px */\r\n  --spacing-36: 9rem;       /* 144px */\r\n  --spacing-40: 10rem;      /* 160px */\r\n  --spacing-44: 11rem;      /* 176px */\r\n  --spacing-48: 12rem;      /* 192px */\r\n  --spacing-52: 13rem;      /* 208px */\r\n  --spacing-56: 14rem;      /* 224px */\r\n  --spacing-60: 15rem;      /* 240px */\r\n  --spacing-64: 16rem;      /* 256px */\r\n  --spacing-72: 18rem;      /* 288px */\r\n  --spacing-80: 20rem;      /* 320px */\r\n  --spacing-96: 24rem;      /* 384px */\r\n  \r\n  /* Border Radius */\r\n  --radius-none: 0;\r\n  --radius-sm: 0.125rem;   /* 2px */\r\n  --radius-base: 0.25rem;  /* 4px */\r\n  --radius-md: 0.375rem;   /* 6px */\r\n  --radius-lg: 0.5rem;     /* 8px */\r\n  --radius-xl: 0.75rem;    /* 12px */\r\n  --radius-2xl: 1rem;      /* 16px */\r\n  --radius-3xl: 1.5rem;    /* 24px */\r\n  --radius-full: 9999px;\r\n  \r\n  /* Border Widths */\r\n  --border-width-0: 0px;\r\n  --border-width-1: 1px;\r\n  --border-width-2: 2px;\r\n  --border-width-4: 4px;\r\n  --border-width-8: 8px;\r\n  \r\n  /* Shadows */\r\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\r\n  --shadow-base: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\r\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\r\n  --shadow-inner: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\r\n  --shadow-none: 0 0 #0000;\r\n  \r\n  /* Transitions */\r\n  --transition-none: none;\r\n  --transition-all: all 150ms cubic-bezier(0.4, 0, 0.2, 1);\r\n  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\r\n  --transition-base: 250ms cubic-bezier(0.4, 0, 0.2, 1);\r\n  --transition-slow: 350ms cubic-bezier(0.4, 0, 0.2, 1);\r\n  --transition-slower: 500ms cubic-bezier(0.4, 0, 0.2, 1);\r\n  \r\n  /* Easing Functions */\r\n  --ease-linear: linear;\r\n  --ease-in: cubic-bezier(0.4, 0, 1, 1);\r\n  --ease-out: cubic-bezier(0, 0, 0.2, 1);\r\n  --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\r\n  \r\n  /* Z-Index Scale */\r\n  --z-auto: auto;\r\n  --z-0: 0;\r\n  --z-10: 10;\r\n  --z-20: 20;\r\n  --z-30: 30;\r\n  --z-40: 40;\r\n  --z-50: 50;\r\n  --z-dropdown: 1000;\r\n  --z-sticky: 1020;\r\n  --z-fixed: 1030;\r\n  --z-modal-backdrop: 1040;\r\n  --z-modal: 1050;\r\n  --z-popover: 1060;\r\n  --z-tooltip: 1070;\r\n  --z-toast: 1080;\r\n  --z-max: 2147483647;\r\n  \r\n  /* Responsive Breakpoints */\r\n  --breakpoint-xs: 475px;\r\n  --breakpoint-sm: 640px;\r\n  --breakpoint-md: 768px;\r\n  --breakpoint-lg: 1024px;\r\n  --breakpoint-xl: 1280px;\r\n  --breakpoint-2xl: 1536px;\r\n  \r\n  /* Container Max Widths */\r\n  --container-xs: 475px;\r\n  --container-sm: 640px;\r\n  --container-md: 768px;\r\n  --container-lg: 1024px;\r\n  --container-xl: 1280px;\r\n  --container-2xl: 1536px;\r\n  \r\n  /* Grid System */\r\n  --grid-columns: 12;\r\n  --grid-gap: var(--spacing-6);\r\n  --grid-gap-sm: var(--spacing-4);\r\n  --grid-gap-lg: var(--spacing-8);\r\n  \r\n  /* Component Specific Variables */\r\n  --navbar-height: 4rem;\r\n  --sidebar-width: 16rem;\r\n  --footer-height: auto;\r\n  \r\n  /* Animation Durations */\r\n  --duration-75: 75ms;\r\n  --duration-100: 100ms;\r\n  --duration-150: 150ms;\r\n  --duration-200: 200ms;\r\n  --duration-300: 300ms;\r\n  --duration-500: 500ms;\r\n  --duration-700: 700ms;\r\n  --duration-1000: 1000ms;\r\n}\r\n\r\n/* High Contrast Theme (Accessibility) */\r\n[data-theme=\"high-contrast\"] {\r\n  --color-background: #000000;\r\n  --color-background-rgb: 0, 0, 0;\r\n  --color-surface: #000000;\r\n  --color-surface-rgb: 0, 0, 0;\r\n  --color-surface-elevated: #1a1a1a;\r\n  --color-surface-elevated-rgb: 26, 26, 26;\r\n  \r\n  --color-text: #ffffff;\r\n  --color-text-rgb: 255, 255, 255;\r\n  --color-text-secondary: #ffffff;\r\n  --color-text-secondary-rgb: 255, 255, 255;\r\n  --color-text-muted: #cccccc;\r\n  --color-text-muted-rgb: 204, 204, 204;\r\n  \r\n  --color-border: #ffffff;\r\n  --color-border-rgb: 255, 255, 255;\r\n  --color-border-light: #cccccc;\r\n  --color-border-light-rgb: 204, 204, 204;\r\n  \r\n  --color-primary: #ffffff;\r\n  --color-primary-rgb: 255, 255, 255;\r\n  --color-secondary: #ffff00;\r\n  --color-secondary-rgb: 255, 255, 0;\r\n  --color-accent: #ff0000;\r\n  --color-accent-rgb: 255, 0, 0;\r\n  \r\n  --color-success: #00ff00;\r\n  --color-success-rgb: 0, 255, 0;\r\n  --color-warning: #ffff00;\r\n  --color-warning-rgb: 255, 255, 0;\r\n  --color-error: #ff0000;\r\n  --color-error-rgb: 255, 0, 0;\r\n  --color-info: #00ffff;\r\n  --color-info-rgb: 0, 255, 255;\r\n}\r\n\r\n/* Reduced Motion Preferences */\r\n@media (prefers-reduced-motion: reduce) {\r\n  :root {\r\n    --transition-none: none;\r\n    --transition-all: none;\r\n    --transition-fast: none;\r\n    --transition-base: none;\r\n    --transition-slow: none;\r\n    --transition-slower: none;\r\n    \r\n    --duration-75: 0ms;\r\n    --duration-100: 0ms;\r\n    --duration-150: 0ms;\r\n    --duration-200: 0ms;\r\n    --duration-300: 0ms;\r\n    --duration-500: 0ms;\r\n    --duration-700: 0ms;\r\n    --duration-1000: 0ms;\r\n  }\r\n}\r\n\r\n/* High Contrast Preference */\r\n@media (prefers-contrast: high) {\r\n  :root:not([data-theme]) {\r\n    --color-border: #000000;\r\n    --color-text: #000000;\r\n    --color-background: #ffffff;\r\n  }\r\n  \r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
